/* eslint-disable @nx/enforce-module-boundaries */
import { ExpandIcon } from '@mybridge/icons/Expand';
import { Card, CloseButton, IconButton, Image, Scrollable } from '@mybridge/ui';
import { MyBridgeLogoMain } from '@mybridge/icons/MyBridgeLogo';
import { Heading } from '@mybridge/ui/heading';
import { Box, HStack, Stack, VStack } from '@mybridge/ui/layout';
import { useRouter } from 'next/router';
import Link from 'next/link';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Spinner } from '@mybridge/ui/spinner';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { PostBoxContext, usePostBoxContext } from 'v4/components/post/context';
import { getPostFunc } from 'v4/lib/api/post';
import { getUserFullName } from 'v4/lib/commons';
import { DashboardPostBox } from '../feed/post-box';
import { isMobile } from 'react-device-detect';
import { BackArrow, MyBridgeCircleIcon } from '@mybridge/icons';
import { ModalreelDisplay } from 'v4/components/post/modal-Reel-display';
import { fetchReels } from 'v4/lib/api/reels';
import { Skeleton } from '@mybridge/ui/skeleton';
import { PostBoxFooter } from 'v4/components/post/footer';
import { PostBoxInsightPlate } from 'v4/components/post/insight-plate';
import { ReelBoxFooterActions } from 'v4/components/post/reel-footer-actions';
import styles from './reelContainer.module.scss';

export const DashboardReelContainer = ({
  page,
  reelId,
  onClose,
  setHasMedia,
  ...props
}) => {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const [showMediaPost, setShowMediaPost] = useState(false);
  const [currentPage, setCurrentPage] = useState(Number(page));

  const [expanded, setExpanded] = useState(false);
  const [activeSliderReelId, setActiveSliderReelId] = useState(reelId);
  const [reelsData, setReelsData] = useState([]);
  const [isNextPageNull, setIsNextPageNull] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [oncePlayed, setOncePlayed] = useState(false);
  const playerRefs = useRef([]);
  const [videoDimensions, setVideoDimensions] = useState({ width: 0, height: 0 });
  const [containerHeight, setContainerHeight] = useState('100vh');

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1000);
  // }, []);
  const { deletedPosts } = useSelector((state) => state.posts ?? {});
  const { loggedIn } = useSelector((state) => state.user);

  useEffect(() => {
    setLoading(true);
    fetchReelsDetails(page).then(()=>{
     setLoading(false); 
    })
  }, []);

  const fetchReelsDetails = async (page=1, isFetchingNext = false) => {
    await fetchReels(Number(page), 6, !loggedIn)
      .then(async (reelResult) => {
        if (reelResult?.results?.length > 0) {
          if (!isFetchingNext) {
            // const startIndex = reelResult.results.findIndex(
            //   (item) => item.id === Number(reelId)
            // );
            // // if (startIndex > -1) {
            //   const data =
            //     startIndex !== -1 ? reelResult.results.slice(startIndex) : reelResult.results;
            //   setReelsData(data);
            //   // playCurrentReels(); // Function not defined, commenting out to avoid crash
            //   if (data.length <= 2) {
            //     reelResult.next !== null &&
            //       fetchReelsDetails(currentPage + 1, true);
            //   }
            // // }

            const startIndex = reelResult.results.findIndex(
              (item) => item.id === Number(reelId)
            );

            let finalData = [];
            
            if (startIndex > -1) {
              finalData = reelResult?.results?.slice(startIndex);
            } else {
              // Not found in current batch, fetch single post as requested
              try {
                const singlePost = await getPostFunc({
                  queryKey: ['getPostDetail', reelId],
                });
                finalData = singlePost
                  ? [singlePost, ...reelResult.results]
                  : reelResult.results;
              } catch (e) {
                finalData = reelResult.results;
              }
            }
            setReelsData(finalData);
            if (finalData.length <= 2) {
              reelResult.next !== null &&
                fetchReelsDetails(currentPage + 1, true);
            }
          } else {
            setCurrentPage(page);
            setReelsData([...reelsData, ...reelResult?.results]);
          }
          setIsNextPageNull(reelResult.next === null);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // query for fetching single post
  const { refetch: fetchPost, data } = useQuery(
    ['getPostDetail', activeSliderReelId],
    getPostFunc,
    {
      refetchOnWindowFocus: false,
      enabled: false,
    }
  );

  const postBoxContext = usePostBoxContext({
    post: data,
    initialFetchComments: true,
  });
  const { refetch, refetchComments, post, hasMedia } = postBoxContext ?? {};

  useEffect(() => {
    setHasMedia?.(true);
  }, [hasMedia]);

  useEffect(() => {
    if (deletedPosts?.includes?.(post?.id)) {
      props?.onClose?.();
    }
  }, [deletedPosts, post]);

  useEffect(() => {
    setTimeout(() => {
      refetch?.();
      refetchComments?.();
    }, 0);
  }, [activeSliderReelId]);

  useEffect(() => {
    if (!oncePlayed) {
      if (reelsData.length > 0) {
        setOncePlayed(true);
        setTimeout(() => {
          const currentRef = playerRefs.current[activeIndex];

          if (currentRef && currentRef?.getInternalPlayer) {
            currentRef?.getInternalPlayer()?.play();
          }
        }, 1000);
      }
    }
  }, [reelsData]);

  useEffect(() => {
    // Pause all videos
    if (playerRefs?.current?.length > 0) {
      playerRefs.current.forEach((playerRef, index) => {
        if (playerRef && playerRef.getInternalPlayer) {
          playerRef.getInternalPlayer().pause();
        }
      });
    }

    // Play the current video
    const currentRef = playerRefs.current[activeIndex];
    if (currentRef && currentRef?.getInternalPlayer) {
      currentRef?.getInternalPlayer()?.play();
    }
  }, [activeIndex]);

  const setPlayerRef = (index) => (ref) => {
    playerRefs.current[index] = ref;
  };

  // const adjustContainerHeight = (videoWidth, videoHeight) => {
  //   const aspectRatio = videoHeight / videoWidth;
  //   const windowWidth = window.innerWidth;
  //   const windowHeight = window.innerHeight;
    
  //   // Calculate optimal height based on video aspect ratio
  //   let optimalHeight;
    
  //   if (windowWidth < 768) {
  //     // Mobile: use full width, adjust height based on aspect ratio
  //     const mobileWidth = windowWidth;
  //     optimalHeight = mobileWidth * aspectRatio;
      
  //     // Limit height to viewport
  //     optimalHeight = Math.min(optimalHeight, windowHeight * 0.9);
  //   } else {
  //     // Desktop: maintain aspect ratio within reasonable bounds
  //     const desktopWidth = Math.min(windowWidth * 0.6, 800); // Max 60% of screen width or 800px
  //     optimalHeight = desktopWidth * aspectRatio;
      
  //     // Limit height to viewport
  //     optimalHeight = Math.min(optimalHeight, windowHeight * 0.9);
  //   }
    
  //   // Set minimum height for very wide videos (landscape)
  //   optimalHeight = Math.max(optimalHeight, windowHeight * 0.4);
    
  //   setContainerHeight(`${optimalHeight}px`);
  // };

  useEffect(() => {
    const getLocalStorage = localStorage.getItem('commentCLicked');
    setShowMediaPost(getLocalStorage);
    fetchPost?.();
  }, [activeSliderReelId]);

  // Handle window resize to recalculate container height
  // useEffect(() => {
  //   const handleResize = () => {
  //     if (videoDimensions.width && videoDimensions.height) {
  //       adjustContainerHeight(videoDimensions.width, videoDimensions.height);
  //     }
  //   };

  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, [videoDimensions]);

  const handleOnClose = (e) => {
    localStorage.removeItem('commentCLicked');
    onClose?.();
  };
  const handlechangeSwipe = (slider) => {
    setActiveIndex(slider.activeIndex);
    setActiveSliderReelId(reelsData[slider?.activeIndex]?.id);
    if (reelsData.length - slider?.activeIndex <= 2 && !isNextPageNull) {
      fetchReelsDetails(currentPage + 1, true);
    }
    router.replace(
      {
        pathname: router.pathname,
        query: {
          reel: reelsData[slider?.activeIndex]?.id,
          page: page,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  const postModalLink = (id) => `?reel=${id}`;

  const handleCommentClicked = () => {
    setExpanded(!expanded);
  };

  return (
    <PostBoxContext.Provider
      value={{
        ...(postBoxContext ?? {}),
        postModalLink,
      }}
    >
      {/* {!hasMedia ? (
        <ModalHeader borderBottom="1px solid #ddd" px={2}>
          <HStack>
            {isMobile && <BackArrow onClick={handleOnClose} />}
            <Heading
              size={['sm', 'md']}
              flex={1}
              textAlign="center"
              color="#3D5A80"
              fontWeight="400"
              zIndex={2}
            >
              {getUserFullName(post?.author)}&apos;s Post
            </Heading>
            {!isMobile && <CloseButton onClick={handleOnClose} />}
          </HStack>
        </ModalHeader>
      ) : null} */}
      <ModalBody p={0} className="reelModalContainer">
        {loading ? (
          <HStack
            pos="absolute"
            inset='0'
            alignItems="center"
            justifyContent="center"
            zIndex="5"
            bg="white"
          >
            <Spinner size="xl" color="black" />
          </HStack>
        ) : (
          ''
        )}
        <HStack
          flexDirection={['column', 'column', 'row']}
          alignItems="stretch"
          spacing={0}
          minH={'100vh'}
          pos="relative"
        >
          {/* {hasMedia ? ( */}
          <>
            <HStack
              pos="fixed"
              top="0"
              left="0"
              right="0"
              zIndex="2"
              px={2}
              maxW={'100px'}
            >
              <HStack bg="transparent" color="white">
                {/* {!isMobile && <CloseButton onClick={handleOnClose} />} */}
                <CloseButton fontSize={['sm', 'sm', 'sm', 'md']} onClick={handleOnClose} />
              </HStack>

              <Box p={2}>
                <Link href="/" as="/">
                  <MyBridgeCircleIcon width={isMobile ? '30px' : '44px'} />
                </Link>
              </Box>
            </HStack>
            <HStack
              // flex={"1 1 80%"}
              flex={1}
              bg="black"
              maxH={expanded ? '100vh' : containerHeight}
              minH={expanded ? '100vh' : containerHeight}
              w="100%"
              maxW={['100%', '100%', expanded ? '100%' : '100%']}
              position="sticky"
              top={0}
              justifyContent="center"
              spacing={0}
              overflowY="hidden"
              _hover={{ overflowY: 'auto' }}
              transition="all 0.3s ease-in-out"
            >
              <div
                className={`${
                  expanded ? styles.container : styles.expendedContainer
                } ${styles.swiperContainer}`}
              >
                <Swiper
                  navigation
                  modules={[Navigation]}
                  onActiveIndexChange={handlechangeSwipe}
                  slidesPerView={1}
                >
                  {reelsData.map?.((post, index) => (
                    <SwiperSlide key={index}>
                      <div className={styles.mainReelSection}>
                        <div className={styles.mediaContainer}>
                          <ModalreelDisplay
                            reelIndex={index}
                            activeIndex={activeIndex}
                            setPlayerRef={setPlayerRef(index)}
                            post={post}
                            isReel={true}
                            fullScreen={expanded}
                            // onVideoLoad={(width, height) => {
                            //   if (index === activeIndex) {
                             //     setVideoDimensions({ width, height });
                             //     adjustContainerHeight(width, height);
                             //   }
                             // }}
                          />
                        </div>
                        <div className={styles.footerAction}>
                          <PostBoxFooter>
                            {post?.id && (
                              <div className={styles.childContainer}>
                                <PostBoxInsightPlate
                                  isActive={expanded}
                                  handleCommentClicked={handleCommentClicked}
                                  isReel={true}
                                />
                                <ReelBoxFooterActions
                                  isActive={expanded}
                                  handleCommentClicked={handleCommentClicked}
                                  isReel={true}
                                />
                              </div>
                            )}
                          </PostBoxFooter>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </HStack>
          </>
          {/* ) : (
            ''
          )} */}
          <Box
            flex={['auto', 'auto', 1]}
            /* maxW={expanded ? '31%' : 0} */
            maxW={isMobile ? (expanded ? '100%' : 0) : (expanded ? '31%' : 0)}
            maxH="100vh"
            overflowY="auto"
          >
            {post?.id ? (
              <DashboardPostBox
                post={post}
                isInFrame={true}
                showMedia={post?.type === 3 || showMediaPost ? true : false}
                showComments={true}
                context={postBoxContext}
              />
            ) : (
              <Skeleton
                maxW={'100%'}
                maxH="100%"
                height="100%"
                alignItems="center"
                justifyContent="center"
              >
                <Spinner />
              </Skeleton>
            )}
          </Box>
        </HStack>
      </ModalBody>
    </PostBoxContext.Provider>
  );
};
